(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/navigation-menu/views/navigation-dimmer.js') >= 0) return;  svs.modules.push('/components/components/navigation-menu/views/navigation-dimmer.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.navigation_menu=_cmps.navigation_menu||{};
_cmps.navigation_menu.templates=_cmps.navigation_menu.templates||{};
svs.components.navigation_menu.templates.navigation_dimmer = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"nav-dimmer js-nav-dimmer\"></div>\n";
},"useData":true});
Handlebars.partials['components-components-navigation_menu-navigation_dimmer'] = svs.components.navigation_menu.templates.navigation_dimmer;
})(svs, Handlebars);

 })(window);